<template>
    <div v-if="image !== null" :class="getWrapClass()">
        <picture :class="getPictureClass()" :style="(keepImageAspectRatio ? 'aspect-ratio: unset' : null)">
            <template v-for="(size, index) in sizes" :key="index">
                <template v-if="size.breakpoint">
                    <source :srcset="getImagePath(size)" :media="(`(min-width: ${size.breakpoint}px)`)" />
                </template>
                <template v-else-if="size.default">
                    <img :src="getImagePath(size)" :class="getImageClass()" :loading="getLoadingType()" :alt="(`${image.Caption}.`)" />
                </template>
            </template>
        </picture>
        <template v-if="image.Caption != null">
            <span :class="getCaptionClass()">{{ image.Caption }}</span>
        </template>
    </div>
</template>
<script>
export default {
    name: 'ImageComponent',
    props: {
        moduleName: {
            type: String,
            default: ''
        },
        cssPrefix: {
            type: String,
            default: null
        },
        createFallback: {
            type: Boolean,
            default: false
        },
        extraPictureClass: {
            type: String,
            default: null
        },
        image: {
            type: Object,
            default: null
        },
        sizes: {
            type: Array,
            default: []
        },
        disableLazyLoading: {
            type: Boolean,
            default: false
        },
        keepImageAspectRatio: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getWrapClass() {
            return `${this.moduleName}__${(this.cssPrefix !== null ? this.cssPrefix : '')}picture-wrap`;
        },
        getPictureClass() {
            return `${this.moduleName}__${(this.cssPrefix !== null ? this.cssPrefix : '')}image-wrap`;
        },
        getImagePath(size) {
            if (this.image.Image.Path.endsWith('.svg')) {
                return this.image.Image.Path;
            }

            let imagePath = `/admin/public/getimage.ashx?image=${encodeURI(this.image.Image.Path)}&crop=7`;
            imagePath += size.width ? `&width=${size.width}` : '';
            imagePath += size.height && !this.keepImageAspectRatio ? `&height=${size.height}` : '';
            imagePath += size.compression ? `&compression=${size.compression}` : '';
            imagePath += this.image.Image.FocalX && this.image.Image.FocalY ? `&x=${this.image.Image.FocalX}&y=${this.image.Image.FocalY}` : '';

            return imagePath;
        },
        getImageClass() {
            return `${this.moduleName}__${(this.cssPrefix !== null ? this.cssPrefix : '')}image`;
        },
        getLoadingType() {
            return this.disableLazyLoading ? 'eager' : 'lazy';
        },
        getCaptionClass() {
            return `${this.moduleName}__${(this.cssPrefix !== null ? this.cssPrefix : '')}image-caption`;
        }
    }
};
</script>
